














import Vue from 'vue'
import Component from 'vue-class-component'
import Select from '@/components/Select.vue'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Select,
    Icon
  },
  props: {
    error: Boolean,
    icon: String,
    title: String,
    items: {
      type: Array,
      required: false
    },
    selected: {
      type: [String, Number, Boolean]
    }
  }
})
export default class TimeCard extends Vue {
}

